import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import CourseList from '../CourseList';
import Downloads from '../Downloads';
import Media from '../Media2';
import Notes from '../Notes';
import Bookmarks from '../Bookmarks';
import Statistics from '../Statistics';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  wrap: {
    background: '#eee',
  },
  content: {
    margin: '30px auto',
  }
}));

const tabs = [
  { link: 'cwiczenia', label: 'Ćwiczenia', component: CourseList },
  { link: 'do-pobrania', label: 'Do pobrania', component: Downloads },
  { link: 'do-sluchania', label: 'Do słuchania', component: Media },
  { link: 'notatki', label: 'Notatki', component: Notes },
  { link: 'zakladki', label: 'Zakładki', component: Bookmarks },
  { link: 'statystyki', label: 'Statystyki', component: Statistics },
];

const links = tabs.reduce((result, tab) => { result.push(tab.link); return result; }, []);
const tabValid = link => links.indexOf(link) > -1;


function TabMenu(props) {
  const classes = useStyles();
  const { params } = props;
  const url = `/kurs/${params.course}/`;
  const currentTab = params.tab;

  if (!tabValid(currentTab) && currentTab !== 'cwiczenia') {
    return <Redirect to="cwiczenia/" />;
  }

  return (
    <>
      <div className={classes.wrap}>
        <div className="container">
          <Tabs value={currentTab} scrollButtons="auto" variant="scrollable">
            {tabs.map((tab, idx) => {
              return <Tab
                key={idx}
                label={tab.label}
                value={tab.link}
                component={Link}
                to={url + tab.link}
              />
            })}
          </Tabs>
        </div>
      </div>
      <div className={clsx('container', classes.content)}>
        {currentTab === 'cwiczenia' && <CourseList />}
        {currentTab === 'do-pobrania' && <Downloads />}
        {currentTab === 'do-sluchania' && <Media />}
        {currentTab === 'notatki' && <Notes />}
        {currentTab === 'zakladki' && <Bookmarks />}
        {currentTab === 'statystyki' && <Statistics />}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    mobile: state.mobile
  }
}

export default connect(mapStateToProps)(TabMenu);
